import React, { FC, useRef, useEffect, useState } from 'react';
import * as S from './styled';
import { useData } from './constants';
import { Slide } from './components/slide';

export const Reviews: FC = props => {
	const data = useData();
	const ref = useRef<HTMLDivElement>(null);
	const refButton = useRef<HTMLButtonElement>(null);
	const [height, setHeight] = useState<number>();
	const [initHeight, setInitHeight] = useState<number>();

	useEffect(() => {
		if (ref.current) {
			let sumHeight = 0;
			const childrenRef = ref.current?.children;
			for (let i = 0; i <= 2; i++) {
				sumHeight = sumHeight + childrenRef[i].getBoundingClientRect().height;
			}
			setInitHeight(ref.current?.getBoundingClientRect().height);
			setHeight(sumHeight + 20);
		}
	}, []);

	function onClick() {
		setHeight(initHeight);
		if (refButton.current) {
			refButton.current.style.display = 'none';
		}
	}

	return (
		<S.Container>
			<S.Title>Customer reviews</S.Title>
			<S.List ref={ref} height={height}>
				{data.map((item, index) => (
					<Slide key={item.name} {...item} />
				))}
			</S.List>
			<S.Button ref={refButton} onClick={onClick}>
				View more
			</S.Button>
		</S.Container>
	);
};
